import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from '../../../utils/redux-injectors';
import { AdminUser } from '../../../types';
import { adminAuthSaga } from './saga';
import { AdminAuthState } from './types';

const TOKEN_KEY = 'sportshub_admin_token';

const storedToken = localStorage.getItem(TOKEN_KEY);

const initialState: AdminAuthState = {
  user: null,
  token: storedToken,
  loading: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    loginRequest(state, _action: PayloadAction<{ email: string; password: string }>) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<{ user: AdminUser; token: string }>) {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem(TOKEN_KEY, action.payload.token);
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.error = null;
      localStorage.removeItem(TOKEN_KEY);
    },
    setUser(state, action: PayloadAction<AdminUser>) {
      state.user = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const adminAuthActions = adminAuthSlice.actions;
export const adminAuthReducer = adminAuthSlice.reducer;
export const initialAdminAuthState = initialState;
export { TOKEN_KEY };

export function useAdminAuthSlice() {
  useInjectReducer({ key: 'adminAuth', reducer: adminAuthSlice.reducer });
  useInjectSaga({ key: 'adminAuth', saga: adminAuthSaga });
  return { actions: adminAuthSlice.actions };
}
